export enum IncodeStep {
  FRONT = "front",
  BACK = "back",
  SELFIE = "selfie",
  BACK_AND_SELFIE = "backAndSelfie",
  DEFAULT = "default",
}

export enum ImageType {
  FRONT = "front",
  BACK = "back",
  SELFIE = "selfie",
}
